import commonService from '@api/commonService';

const actions = {
    dataRequest: ({commit}, payload) => {
        let data = {
            'type': payload.type
        }

        return new Promise((resolve, reject) => {
            commonService.getData(data)
                .then((resp) => {
                    commit('DATA_SUCCESS', {type: payload.type, response: resp.data});
                    // resolve(resp);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('DATA_ERROR', errors);
                    // reject(err);
                })
        })
    }
}

export default actions
